module.exports = __webpack_public_path__ + "img/IMG_5837.1ef40563.jpg";